import { type LinkProps } from "react-router-dom"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgArrowLeft } from "@digits-shared/components/SVGIcons/line/ArrowLeft.svg"
import {
  type ButtonProps,
  DigitsButton,
  type DigitsButtonProps,
} from "@digits-shared/DesignSystem/Button"
import { DigitsLinkButton } from "@digits-shared/DesignSystem/LinkButton"
import colors from "@digits-shared/themes/colors"
import { styled } from "styled-components"

export const BackIcon = styled(SvgArrowLeft)`
  width: 16px;
  height: 16px;
  ${svgPathStyles(colors.white)}
`

type ButtonLinkProps = ButtonProps & LinkProps

export const BackButtonPill: React.FC<DigitsButtonProps> = (props) => (
  <DigitsButton $variant="secondary-dark" size="small" aria-label="Back" {...props}>
    <BackIcon />
    Back
  </DigitsButton>
)

export const BackLinkButtonPill: React.FC<ButtonProps & LinkProps> = (props) => (
  <DigitsLinkButton $variant="secondary-dark" size="small" aria-label="Back" {...props}>
    <BackIcon />
    Back
  </DigitsLinkButton>
)

export const BackPill: React.FC<DigitsButtonProps | ButtonLinkProps> = (props) =>
  isLinkProps(props) ? <BackLinkButtonPill {...props} /> : <BackButtonPill {...props} />

function isLinkProps(props: DigitsButtonProps | ButtonLinkProps): props is ButtonLinkProps {
  return typeof (props as ButtonLinkProps).to !== "undefined"
}
